<template>
  <layout>
    <template v-slot:header>
      <h2>Ship Items for User {{ user.company_name }}  {{ user.first_name }} {{ user.last_name }} #</h2>
      <flash-messages />
    </template>
    
    <template v-slot:default>
      <div class="row">
        <div class="col-12">
          Packages:
          <div v-for="box in boxes" :key="box.id" class="box-item">
            <div class="row">
              <div class='col-sm-4'>
                <div class="form-row mb-3">
                  <select class="form-control" v-model="box.type">
                    <option v-for="type in boxTypes" :key="type.code" :value="type.code">{{ type.code }}: {{ type.width }} x {{ type.length }} x {{ type.depth }}</option>
                  </select>
                </div>
                <div class="form-row mb-3">
                  <label class="mr-2">Weight:</label> 
                  <input class="form-control custom-form-inline" type="text" v-model="box.weight">
                </div>
              </div>
              <div class='col-sm-8'>
                <table>
                  <tr class="d-flex align-items-end">
                    <td><strong class="mr-2">New Box:</strong></td>
                    <td>Code: <input type="text" class="form-control custom-form-inline" v-model="formBox.code"></td>
                    <td>W: <input type="text" class="form-control custom-form-inline" v-model="formBox.width" style="width: 50px"></td>
                    <td>L: <input type="text" class="form-control custom-form-inline" v-model="formBox.length" style="width: 50px"></td>
                    <td>D: <input type="text" class="form-control custom-form-inline" v-model="formBox.depth" style="width: 50px"></td>
                    <td>
                      <button type="button" class="btn btn-success ml-2" @click="createBox(box)">Create Box</button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="items">
              <table width="100%">
                <tr v-for="item in box.items" :key="item.id">
                  <td width="100">
                    <input type="text" class="form-control custom-form-inline" v-model="item.qty"/>
                  </td>
                  <td> {{ item.sku }}</td>
                  <td> {{ item.name }}</td>
                </tr>
              </table>
            </div>
          </div>

          <button type="button" class="btn btn-success mt-3" @click="addBox()">Add Shipment Package</button>
          <br/><br/>
          Selected Method: {{ shipment.method_label }} -  Override Method: 
          <select class="form-control" v-model="form.shipping_method_id">
            <option v-for="(label, code) in methods" :value="code">{{ code }}: {{ label }}</option>
          </select>
          <br/><br/>
          <button type="button" class="btn btn-success" @click="createShipment()">Create Shipment</button>

          <div class="ship-address mt-3 mb-3">
            Ship To:<br/>
            {{ shipment.address.company_name }}<br/>
            {{ shipment.address.address1 }}
            {{ shipment.address.address2 }}<br/>
            {{ shipment.address.city }}, {{ shipment.address.state }} {{ shipment.address.postcode }}
          </div>

          Expected {{ boxes_suggested.length }} boxes:
          <div v-for="box in boxes_suggested" :key="box.id">
            {{ box.box_size }}
            <div v-for="item in box.items" :key="item.id">
              {{ item.sku }} {{ item.name }} x {{ item.qty }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </layout>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'
  import FlashMessages from '@/Shared/FlashMessages'
  
  import JetDialogModal from '@/Jetstream/DialogModal'
  import JetDangerButton from '@/Jetstream/DangerButton'

  import moment from 'moment'
  import toastr from 'toastr'

  export default {
    components: {
      FlashMessages,
      Layout,
      JetDialogModal,
      JetDangerButton,
    },
    props: {
      shipment: Object,
      user: Object,
      items: Array,
      carriers: Array,
      shipments: Array,
      notes: Array,
      boxes_suggested: Array,
      box_types: Array,
      methods: Array
    },
    data() {
      return {
          shipItem: null,
          boxes: [],
          boxTypes: this.box_types,
        form: this.$inertia.form({
          _method: 'put',
          shipping_method_id: null,
          items: null
        }),

        formBox: this.$inertia.form({
          _method: 'put',
          code: null,
          width: 0,
          length: 0,
          depth: 0
        })      
      }
    },
    created() {
      this.moment = moment;
    },
    mounted() {
      this.addBox()
    },
    methods: {
      addBox() {
        let newItems = [];
        for (var i=0; i<this.items.length; i++) {
          let remaining = this.remaining(this.items[i]);

          if (remaining > 0) {
            newItems[newItems.length] = {
              qty: remaining,
              product_id: this.items[i].product_id,
              name: this.items[i].name,
              sku: this.items[i].sku
            };
          }
        }
        if (newItems.length > 0) {
          this.boxes[this.boxes.length] = {
            type: null,
            weight: null,
            items: newItems
          };
        } else { 
          toastr.error("No items remaining.");
        }
      },
      remaining(item) {
        let remaining = 0;
        for (var i=0; i<this.items.length; i++) {
          if (item.product_id == this.items[i].product_id) {
            remaining = this.items[i].qty;
          }
        }
        for (var i=0; i<this.boxes.length; i++) {
          for (var j=0; j<this.boxes[i].items.length; j++) {
            if (item.product_id == this.boxes[i].items[j].product_id) {
              remaining -= this.boxes[i].items[j].qty;
            }
          }
        }

        return remaining;
      },
      selectItem(e, item) {
        for (var i=0; i<this.items.length; i++) {
          if (item.id == this.items[i].id) {
            if (e.target.checked) {
              this.items[i].selected = true;
            } else {
              this.items[i].selected = false;
            }
          }
        }
      },
      createShipment() {
        if (this.boxes.length > 0) {
          for (var i=0; i<this.boxes.length; i++) {
            if (!this.boxes[i].type) {
              toastr.error("Box #" + (i+1) + " needs a type.");
              return;
            }
            if (!this.boxes[i].weight) {
              toastr.error("Box #" + (i+1) + " needs weight entered.");
              return;
            }
          }
          for (var i=0; i<this.items.length; i++) {
            let remaining = this.remaining(this.items[i]);

            if (remaining > 0) {
              toastr.error(remaining + " of item " + this.items[i].name + " not in packages.");
              return;
            }
          }
          this.form.items = JSON.stringify(this.boxes);
          this.form.post(this.route('admin.shipment.submit', this.shipment))
        }
      },
      add() {
      },
      selectTrack(shipItem) {
          this.shipItem = shipItem;
          $('#trackModal').modal('show');

      },
      hideTrack() {
          this.shipItem = null;
          $('#trackModal').modal('hide');

      },
      addNote() {
          this.formNote.post(this.route('admin.orders.addnote', this.order.id))
      },
      createBox(box) {
        let component = this;
        axios.post(this.route('admin.box.store'), {
                      code: this.formBox.code,
                      width: this.formBox.width,
                      length: this.formBox.length,
                      depth: this.formBox.depth
                }).then((response) => {
                  component.boxTypes = response.data.boxes;
                  box.type = component.formBox.code;
                });
      },
    },
  }
</script>

<style>
  div .box-item {
    border: #cccccc 1px solid;
    margin: 1em 0;
    padding: 3em;
  }
</style>